import Page from 'components/Page';
import React, { useState } from 'react';
import { styled } from '@mui/system';
import Tab from 'components/Tab';
import {
  Box,
  Input,
  Typography,
  InputAdornment,
  Stack,
  Button,
} from '@mui/material';
import Search from '@mui/icons-material/Search';
import { Table, Th, Tr, Td, TdTable } from 'components/Table';
import { useNavigate } from 'react-router-dom';
import CashModal from 'components/CashModal';
import plussIoutlined from '@iconify/icons-ant-design/plus-outlined';
import { Icon } from '@iconify/react';
import useCoachList from 'hook/useCoachList';
import NewCoachModal from 'components/NewCoachModal';
import EditCoachModal from 'components/EditCoachModal';
import { CoachUser } from 'model/Settlements';
import { RootStyle } from './style';

const Avatar = styled('img')`
  width: 36px;
  margin-right: 12px;
`;

export default function Coach() {
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();
  const [isOpenCashModal, setIsOpenCashModal] = useState(false);
  const [editCoach, setEditCoach] = useState<CoachUser | undefined>(undefined);
  const { data, isLoading } = useCoachList();
  const [search, setSearch] = useState('');
  return (
    <Page
      actions={
        <Button variant='contained' onClick={() => setIsOpenCashModal(true)}>
          코치 추가하기
        </Button>
      }
    >
      <Stack direction='row' justifyContent='flex-end' mb={5}>
        <Box>
          <Input
            id='input-with-icon-adornment'
            placeholder='코치를 검색하세요'
            startAdornment={
              <InputAdornment position='start'>
                <Search />
              </InputAdornment>
            }
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Box>
      </Stack>
      <Table>
        <Tr>
          <Th>코치 이름</Th>
          <Th>닉네임(앱)</Th>
        </Tr>
        {data?.items
          .filter((coach) => coach.name.includes(search))
          .map((item) => (
            <Tr>
              <Td
                style={{ cursor: 'pointer' }}
                onClick={() => setEditCoach(item)}
              >
                <Typography fontWeight={700}>{item.name}</Typography>
              </Td>
              <Td>
                <Avatar src={item.avatar_url} alt='profile' />
                {item.nickname}
              </Td>
            </Tr>
          ))}
      </Table>
      <NewCoachModal
        isOpen={isOpenCashModal}
        close={() => setIsOpenCashModal(false)}
      />
      <EditCoachModal
        isOpen={!!editCoach}
        close={() => setEditCoach(undefined)}
        coach={editCoach}
      />
    </Page>
  );
}
